const AppConsts = {
  userManagement: {
    defaultAdminUserName: 'admin',
  },
  localization: {
    defaultLocalizationSourceName: 'ZeroGeek',
  },
  authorization: {
    encrptedAuthTokenName: 'enc_auth_token',
    impersonateTokenName: 'ZeroG33K-ImpersonateToken',
  },
  appBaseUrl: import.meta.env.VITE_APP_BASE_URL,
  remoteServiceBaseUrl: import.meta.env.VITE_REMOTE_SERVICE_BASE_URL,
  remoteInfrastructureServiceBaseUrl: import.meta.env.VITE_INFRASTRUCTURE_SERVICE_BASE_URL,
  mobileAppUrl: import.meta.env.VITE_MOBILE_APP_URL || '',

  streamApiKey: import.meta.env.VITE_STREAM_API_KEY,
  vehicleApiKey: import.meta.env.VITE_VEHICLE_KEY,

  hotjarSiteId: import.meta.env.VITE_HOTJAR_SITE_ID,
  hotjarVersion: import.meta.env.VITE_HOTJAR_VERSION,

  clarityProjectId: import.meta.env.VITE_CLARITY_PROJECT_ID,

  financeReport: import.meta.env.VITE_FINANCE_REPORT,
  headlineReport: import.meta.env.VITE_HEADLINE_REPORT,
  utilizationReport: import.meta.env.VITE_UTILIZATION_REPORT,
  customerReport: import.meta.env.VITE_CUSTOMER_REPORT,
};
export default AppConsts;
